import { Component, Input } from '@angular/core';
import { IConsumedDetail } from 'libraries/pipes/configurable-table/compute-value.pipe';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from "@fortawesome/free-regular-svg-icons";
import { BtnStyleTypes } from 'libraries/ui_button/btn.component';
import { Yii } from "libraries/interfaces/Yii";

@Component({
    selector: 'consumed-detail',
    template: `
        <ng-container *ngIf="consumedDetail && consumedDetail?.value && isDataAvailable()">
            <div class="align">
                <span class="label">{{ consumedDetail?.label }}</span>
                <span class="chart-wrapper">
                <chart-bar [value]="[consumedDetail?.value?.usedPercentage, consumedDetail?.value?.pendingPercentage]"
                           [total]="100"
                           [showAsActive]="true" class="custom-chart-bar">
                </chart-bar>
            </span>
                <btn [type]="btnTypes.actionLink" (onClick)="toggleRowVisibility()">
                    <fa-icon [icon]="collapsedRow ? iconAngleUp : iconAngleDown" class="icon"></fa-icon>
                </btn>
            </div>
            <div *ngIf="collapsedRow">
                <div>
                    <span>{{ issuedValue }}</span> <span class="value" [innerHTML]="consumedDetail?.value?.issuedValue"></span>
                </div>
                <div>
                    <span>{{ pendingValue }}</span> <span class="valuePending" [innerHTML]="consumedDetail?.value?.pendingValue"></span>
                </div>
                <div>
                    <span>{{ pendingPercentage }}</span> <span class="valuePending" [innerHTML]="consumedDetail?.value?.pendingPercentage + '%'"></span>
                </div>
                <div>
                    <span>{{ usedValue }}</span> <span class="valueUsed" [innerHTML]="consumedDetail?.value?.usedValue"></span>
                </div>
                <div>
                    <span>{{ usedPercentage }}</span> <span class="valueUsed" [innerHTML]="consumedDetail?.value?.usedPercentage + '%'"></span>
                </div>
            </div>
        </ng-container>
    `,
    styles: [`
        .valueUsed {
            color: #00B050;
            font-weight: bolder;
        }

        .valuePending {
            color: #c77405;
            font-weight: bolder;
        }

        .value {
            font-weight: bolder;
        }

        .align {
            display: flex;
            align-items: center;
        }

        .label {
            margin-right: 10px;
        }

        .chart-wrapper {
            width: 50%;
        }
    `]
})
export class ConsumedDetailComponent {
    @Input()
    public consumedDetail: IConsumedDetail;

    public btnTypes: { actionLink: BtnStyleTypes } = {
        actionLink: 'action-link' as BtnStyleTypes
    };

    public collapsedRow: boolean = false;

    public iconAngleUp: IconDefinition = faAngleUp;
    public iconAngleDown: IconDefinition = faAngleDown;
    public issuedValue: string = Yii.t('wui-sasha-js', "Total billet émis :");
    public usedValue: string = Yii.t('wui-sasha-js', "Total billet utilisés :");
    public usedPercentage: string = Yii.t('wui-sasha-js', "Pourcentage billet utilisés :");
    public pendingValue: string = Yii.t('wui-sasha-js', "Total billet en attente :");
    public pendingPercentage: string = Yii.t('wui-sasha-js', "Pourcentage billet en attente :");

    public toggleRowVisibility(): void {
        this.collapsedRow = !this.collapsedRow;
    }

    public isDataAvailable(): boolean {
        return (
            this.consumedDetail?.value?.usedPercentage !== undefined ||
            this.consumedDetail?.value?.pendingPercentage !== undefined ||
            this.consumedDetail?.value?.usedValue !== undefined ||
            this.consumedDetail?.value?.pendingValue !== undefined ||
            this.consumedDetail?.value?.issuedValue !== undefined
        );
    }
}
